import React, { useEffect, useState } from 'react';
import { ref, get, set, push, update, query, orderByChild, equalTo } from 'firebase/database';
import { database } from '../firebase/config';
import { Document, Image, Page, StyleSheet, Text, View, pdf } from '@react-pdf/renderer';

const IVA_ALIQUOTA = 0.081;

const DATI_AZIENDA = {
  nome: 'C.R.G. Scavi e trasporti Sagl',
  indirizzo: 'Via Livio 5, 6830 Chiasso TI',
  contatti: 'Tel. +41 78 751 32 51 - email: info@crgscavi.ch',
  iva: 'IVA: CHE-285.549.695',

};

const UNITA_DISPONIBILI = ['ore', 'km', 'm3', 'quintali', 'a corpo'];

const pdfStyles = StyleSheet.create({
  page: {
    padding: 30,
    fontSize: 10,
    fontFamily: 'Helvetica',
  },
  intestazione: {
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: 16,
    paddingBottom: 10,
    borderBottom: '1 solid #ccc',
  },
  logoImg: {
    width: 80,
    height: 32,
    objectFit: 'contain',
  },
  recapiti: {
    marginLeft: 12,
    fontSize: 9,
    color: '#333',
  },
  recapitiNome: {
    fontSize: 10,
    fontWeight: 'bold',
    marginBottom: 2,
  },
  intestazioneRigheContainer: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginBottom: 44,
  },
  blocSinistra: {
    width: '45%',
  },
  blocDestra: {
    width: '45%',
  },
  label: {
    fontWeight: 'bold',
  },
  titolo: {
    fontSize: 16,
    fontWeight: 'bold',
    textAlign: 'center',
    marginBottom: 16,
  },
  cantiereRiga: {
    backgroundColor: '#eee',
    padding: 6,
    marginBottom: 8,
    fontWeight: 'bold',
  },
  tableHeader: {
    flexDirection: 'row',
    backgroundColor: '#1a1a1a',
    padding: 5,
    color: '#fff',
    fontWeight: 'bold',
  },
  tableRow: {
    flexDirection: 'row',
    padding: 5,
    borderBottom: '1 solid #ccc',
  },
colDescr: {
  width: '38%',
},
colUnita: {
  width: '8%',
},
colQta: {
  width: '10%',
},
colPrezzo: {
  width: '14%',
},
colSconto: {
  width: '10%',
  textAlign: 'right',
},
colTotale: {
  width: '20%',
  textAlign: 'right',
},
  totaliBox: {
    marginTop: 16,
    alignSelf: 'flex-end',
    width: '45%',
  },
  totaliRiga: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    paddingVertical: 2,
  },
totaliRigaFinale: {
  flexDirection: 'row',
  justifyContent: 'space-between',
  paddingVertical: 4,
  borderTop: '1 solid #333',
  marginTop: 4,
  fontWeight: 'bold',
  fontSize: 12,
},
condizioniBox: {
  marginTop: 20,
  width: '55%',
},
condizioniRiga: {
  flexDirection: 'row',
  marginBottom: 4,
},
condizioniLabel: {
  fontWeight: 'bold',
  width: 130,
},
});

function fmtDataIT(isoDate) {
  if (!isoDate) return '';
  const parts = isoDate.split('-');
  if (parts.length !== 3) return isoDate;
  return `${parts[2]}.${parts[1]}.${parts[0]}`;
}

function fmtCHF(numero) {
  const n = Number(numero) || 0;
  const negativo = n < 0;
  const numeroAbs = Math.abs(n).toFixed(2);
  const [parteIntera, parteDecimale] = numeroAbs.split('.');
  const parteInteraFormattata = parteIntera.replace(/\B(?=(\d{3})+(?!\d))/g, "'");
  return (negativo ? '-' : '') + parteInteraFormattata + '.' + parteDecimale;
}

function PreventivoPDF({ dati }) {
  const {
    numeroPreventivo,
    dataPreventivo,
    clienteObj,
    cantiereObj,
    oggettoPreventivo,
    acconto,
    saldo,
    validitaPreventivo,
    righe,
    scontoPercento,
    subtotale,
    imponibile,
    iva,
    totale,
  } = dati;

  return (
    <Document>
      <Page size="A4" style={pdfStyles.page}>
        <View style={pdfStyles.intestazione}>
          <Image src="/CRG_logo.png" style={pdfStyles.logoImg} />
          <View style={pdfStyles.recapiti}>
            <Text style={pdfStyles.recapitiNome}>{DATI_AZIENDA.nome}</Text>
            <Text>{DATI_AZIENDA.indirizzo}</Text>
            <Text>{DATI_AZIENDA.contatti}</Text>
            <Text>{DATI_AZIENDA.iva}</Text>
          </View>
        </View>

        <Text style={pdfStyles.titolo}>PREVENTIVO</Text>

        <View style={pdfStyles.intestazioneRigheContainer}>
          <View style={pdfStyles.blocSinistra}>
            <Text>
              <Text style={pdfStyles.label}>Chiasso, </Text>
              {fmtDataIT(dataPreventivo)}
            </Text>
            <Text>
              <Text style={pdfStyles.label}>Preventivo N°: </Text>
              {numeroPreventivo}
            </Text>
          </View>

          <View style={pdfStyles.blocDestra}>
            <Text style={pdfStyles.label}>Spett.le</Text>
            <Text style={{ marginBottom: 12 }}>{clienteObj?.ragioneSociale || ''}</Text>
            {clienteObj?.indirizzo ? <Text>{clienteObj.indirizzo}</Text> : null}
            {(clienteObj?.cap || clienteObj?.citta) ? (
              <Text>{[clienteObj.cap, clienteObj.citta].filter(Boolean).join(' ')}</Text>
            ) : null}
          </View>
        </View>


        {oggettoPreventivo ? (
          <Text style={pdfStyles.oggettoRiga}>
            Oggetto: {oggettoPreventivo}
          </Text>
        ) : null}

        {cantiereObj ? (
          <Text style={pdfStyles.cantiereRiga}>
            Cantiere: {cantiereObj.luogo}
          </Text>
        ) : null}

<View style={pdfStyles.tableHeader}>
  <Text style={pdfStyles.colDescr}>Descrizione</Text>
  <Text style={pdfStyles.colUnita}>U</Text>
  <Text style={pdfStyles.colQta}>Q.tà</Text>
  <Text style={pdfStyles.colPrezzo}>Prezzo CHF</Text>
  <Text style={pdfStyles.colSconto}>Sconto %</Text>
  <Text style={pdfStyles.colTotale}>Totale CHF</Text>
</View>

{righe.map((riga, indice) => (
  <View key={indice} style={pdfStyles.tableRow}>
    <Text style={pdfStyles.colDescr}>{riga.descrizione}</Text>
    <Text style={pdfStyles.colUnita}>{riga.unita}</Text>
    <Text style={pdfStyles.colQta}>{riga.quantita}</Text>
    <Text style={pdfStyles.colPrezzo}>{fmtCHF(riga.prezzo)}</Text>
    <Text style={pdfStyles.colSconto}>
      {riga.scontoRiga ? `${riga.scontoRiga}%` : '-'}
    </Text>
    <Text style={pdfStyles.colTotale}>{fmtCHF(riga.totale)}</Text>
  </View>
))}

        <View style={pdfStyles.totaliBox}>
          <View style={pdfStyles.totaliRiga}>
            <Text>Subtotale</Text>
            <Text>CHF {fmtCHF(subtotale)}</Text>
          </View>

          {scontoPercento > 0 && (
            <View style={pdfStyles.totaliRiga}>
              <Text>Sconto {scontoPercento}%</Text>
              <Text>- CHF {fmtCHF(subtotale - imponibile)}</Text>
            </View>
          )}

          <View style={pdfStyles.totaliRiga}>
            <Text>Imponibile</Text>
            <Text>CHF {fmtCHF(imponibile)}</Text>
          </View>

          <View style={pdfStyles.totaliRiga}>
            <Text>IVA 8.1%</Text>
            <Text>CHF {fmtCHF(iva)}</Text>
          </View>

<View style={pdfStyles.totaliRigaFinale}>
  <Text>TOTALE</Text>
  <Text>CHF {fmtCHF(totale)}</Text>
</View>
</View>

<View style={pdfStyles.condizioniBox}>
  {acconto ? (
    <View style={pdfStyles.condizioniRiga}>
      <Text style={pdfStyles.condizioniLabel}>Acconto:</Text>
      <Text>{acconto}</Text>
    </View>
  ) : null}
  {saldo ? (
    <View style={pdfStyles.condizioniRiga}>
      <Text style={pdfStyles.condizioniLabel}>Saldo:</Text>
      <Text>{saldo}</Text>
    </View>
  ) : null}
  {validitaPreventivo ? (
    <View style={pdfStyles.condizioniRiga}>
      <Text style={pdfStyles.condizioniLabel}>Validità del preventivo:</Text>
      <Text>{validitaPreventivo}</Text>
    </View>
  ) : null}
</View>
</Page>
</Document>
);
}

export default function CreaPreventivoForm({ onBack, preventivoDaModificare }) {
const oggi = new Date().toISOString().split('T')[0];

const [clienti, setClienti] = useState([]);
const [cantieri, setCantieri] = useState([]);
const [numeroPreventivo, setNumeroPreventivo] = useState(preventivoDaModificare?.numeroPreventivo || '');
const [dataPreventivo, setDataPreventivo] = useState(preventivoDaModificare?.dataPreventivo || oggi);
const [clienteId, setClienteId] = useState(preventivoDaModificare?.clienteId || '');
const [cantiereId, setCantiereId] = useState(preventivoDaModificare?.cantiereId || '');
const [righe, setRighe] = useState(preventivoDaModificare?.righe || []);
const [scontoPercento, setScontoPercento] = useState(preventivoDaModificare?.scontoPercento || 0);
const [oggettoPreventivo, setOggettoPreventivo] = useState(preventivoDaModificare?.oggettoPreventivo || '');
const [acconto, setAcconto] = useState(preventivoDaModificare?.acconto || '');
const [saldo, setSaldo] = useState(preventivoDaModificare?.saldo || '');
const [validitaPreventivo, setValiditaPreventivo] = useState(preventivoDaModificare?.validitaPreventivo || '');
const [saving, setSaving] = useState(false);

  useEffect(() => {
    async function caricaDati() {
      try {
        const [clientiSnap, cantieriSnap] = await Promise.all([
          get(ref(database, 'clienti')),
          get(ref(database, 'cantieri')),
        ]);

        if (clientiSnap.exists()) {
          setClienti(
            Object.entries(clientiSnap.val()).map(([id, valore]) => ({
              id,
              ...valore,
            }))
          );
        }

        if (cantieriSnap.exists()) {
          setCantieri(
            Object.entries(cantieriSnap.val()).map(([id, valore]) => ({
              id,
              ...valore,
            }))
          );
        }
      } catch (errore) {
        console.error('Errore caricamento anagrafiche preventivo:', errore);
        alert('Errore nel caricamento di clienti e cantieri.');
      }
    }

    caricaDati();
  }, []);

  const cantieriFiltrati = clienteId
    ? cantieri.filter((cantiere) => cantiere.clienteId === clienteId)
    : cantieri;

function aggiungiRigaManuale() {
    setRighe((precedenti) => [
      ...precedenti,
      {
        descrizione: '',
        unita: 'ore',
        quantita: '',
        prezzo: '',
        scontoRiga: '',
        totale: 0,
      },
    ]);
  }

function aggiornaRiga(indice, campo, valore) {
    setRighe((precedenti) => {
      const copia = [...precedenti];

      const rigaAggiornata = {
        ...copia[indice],
        [campo]: valore,
      };

      const quantita = parseFloat(rigaAggiornata.quantita) || 0;
      const prezzo = parseFloat(rigaAggiornata.prezzo) || 0;
      const scontoRigaPercento = parseFloat(rigaAggiornata.scontoRiga) || 0;

      const totaleBase = quantita * prezzo;
      rigaAggiornata.totale = totaleBase - (totaleBase * scontoRigaPercento / 100);
      copia[indice] = rigaAggiornata;

      return copia;
    });
  }

  function rimuoviRiga(indice) {
    setRighe((precedenti) =>
      precedenti.filter((_, index) => index !== indice)
    );
  }

  const subtotale = righe.reduce(
    (somma, riga) => somma + (Number(riga.totale) || 0),
    0
  );

  const scontoValore =
    subtotale * ((parseFloat(scontoPercento) || 0) / 100);

  const imponibile = subtotale - scontoValore;
  const iva = imponibile * IVA_ALIQUOTA;
  const totale = imponibile + iva;

  async function salvaPreventivo() {
    if (!numeroPreventivo.trim()) {
      alert('Inserisci il numero preventivo.');
      return;
    }

    if (!clienteId) {
      alert('Seleziona un cliente.');
      return;
    }

// Controllo duplicato numero preventivo (salta se è lo stesso preventivo in modifica)
const numero = numeroPreventivo.trim();
const preventiviRef = ref(database, 'preventivi');
const q = query(preventiviRef, orderByChild('numeroPreventivo'), equalTo(numero));
const snap = await get(q);

if (snap.exists()) {
  let duplicatoDiAltroPreventivo = false;
  snap.forEach((child) => {
    if (child.key !== preventivoDaModificare?.id) {
      duplicatoDiAltroPreventivo = true;
    }
  });
  if (duplicatoDiAltroPreventivo) {
    alert('Esiste già un preventivo con questo numero. Usa un numero diverso.');
    return;
  }
}

    if (righe.length === 0) {
      alert('Aggiungi almeno una riga al preventivo.');
      return;
    }

    const righeNonValide = righe.some(
      (riga) =>
        !riga.descrizione.trim() ||
        !riga.unita ||
        Number(riga.quantita) <= 0 ||
        Number(riga.prezzo) < 0
    );

    if (righeNonValide) {
      alert(
        'Controlla tutte le righe: descrizione obbligatoria, quantità maggiore di zero e prezzo valido.'
      );
      return;
    }

    setSaving(true);

    try {
      const clienteObj = clienti.find((cliente) => cliente.id === clienteId);
      const cantiereObj = cantieri.find(
        (cantiere) => cantiere.id === cantiereId
      );

const datiPDF = {
  numeroPreventivo: numeroPreventivo.trim(),
  dataPreventivo,
  clienteObj,
  cantiereObj,
  oggettoPreventivo: oggettoPreventivo.trim(),
  acconto: acconto.trim(),
  saldo: saldo.trim(),
  validitaPreventivo: validitaPreventivo.trim(),
  righe,
  scontoPercento: parseFloat(scontoPercento) || 0,
  subtotale,
  imponibile,
  iva,
  totale,
};

      const blob = await pdf(<PreventivoPDF dati={datiPDF} />).toBlob();

      const clienteNomeFile = (clienteObj?.ragioneSociale || 'cliente')
        .replace(/[^a-zA-Z0-9]/g, '_')
        .toLowerCase();

      const numeroNomeFile = numeroPreventivo
        .trim()
        .replace(/[^a-zA-Z0-9]/g, '_');

      const nomeFile = `preventivo-${numeroNomeFile}-${clienteNomeFile}.pdf`;

      const url = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = nomeFile;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);

const preventivoRecord = {
  numeroPreventivo: numeroPreventivo.trim(),
  dataPreventivo,
  clienteId,
  cantiereId: cantiereId || null,
  oggettoPreventivo: oggettoPreventivo.trim(),
  acconto: acconto.trim(),
  saldo: saldo.trim(),
  validitaPreventivo: validitaPreventivo.trim(),
  righe,
  scontoPercento: parseFloat(scontoPercento) || 0,
  subtotale,
  imponibile,
  iva,
  totale,
  spedito: preventivoDaModificare?.spedito || false,
  accettato: preventivoDaModificare?.accettato || false,
  fatturato: preventivoDaModificare?.fatturato || false,
  createdAt: preventivoDaModificare?.createdAt || Date.now(),
};

if (preventivoDaModificare?.id) {
  await update(ref(database, `preventivi/${preventivoDaModificare.id}`), preventivoRecord);
  alert('Preventivo modificato, PDF aggiornato scaricato e salvato.');
  if (onBack) onBack();
} else {
  const nuovoPreventivoRef = push(ref(database, 'preventivi'));
  await set(nuovoPreventivoRef, preventivoRecord);

  alert('Preventivo generato, PDF scaricato e preventivo salvato.');

  setNumeroPreventivo('');
  setClienteId('');
  setCantiereId('');
  setOggettoPreventivo('');
  setAcconto('');
  setSaldo('');
  setValiditaPreventivo('');
  setRighe([]);
  setScontoPercento(0);
}
    } catch (errore) {
      console.error('Errore salvataggio preventivo:', errore);
      alert('Errore durante il salvataggio del preventivo: ' + errore.message);
    } finally {
      setSaving(false);
    }
  }

  return (
    <div className="fatturazione-page">


<div className="fatturazione-header">
  <button
    type="button"
    className="btn-logout"
    onClick={onBack}
  >
    Torna indietro
  </button>
</div>


      <div className="form-bolla fatturazione-form">
  	<h2>{preventivoDaModificare ? 'Modifica Preventivo' : 'Nuovo Preventivo'}</h2>

        <div className="form-group">
          <label>Numero preventivo</label>
          <input
            type="text"
            value={numeroPreventivo}
            onChange={(e) => setNumeroPreventivo(e.target.value)}
            placeholder="Es. PREV-2026-001"
          />
        </div>

<div className="form-group">
  <label>Data </label>
  <input
    type="date"
    value={dataPreventivo}
    onChange={(e) => setDataPreventivo(e.target.value)}
  />
</div>

        <div className="form-group">
          <label>Cliente (Spett.le)</label>
          <select
            value={clienteId}
            onChange={(e) => {
              setClienteId(e.target.value);
              setCantiereId('');
            }}
          >
            <option value="">Seleziona cliente</option>
            {clienti.map((cliente) => (
              <option key={cliente.id} value={cliente.id}>
                {cliente.ragioneSociale}
              </option>
            ))}
          </select>
        </div>

        <div className="form-group">
          <label>Cantiere</label>
          <select
            value={cantiereId}
            onChange={(e) => setCantiereId(e.target.value)}
          >
            <option value="">- Nessun cantiere -</option>
            {cantieriFiltrati.map((cantiere) => (
              <option key={cantiere.id} value={cantiere.id}>
                {cantiere.luogo}
              </option>
            ))}
          </select>
        </div>


<div className="form-group">
  <label>Oggetto preventivo</label>
  <input
    type="text"
    value={oggettoPreventivo}
    onChange={(e) => setOggettoPreventivo(e.target.value)}
    placeholder="Es. Scavo e trasporto materiale di risulta"
  />
</div>

<div className="form-group">
  <label>Acconto</label>
  <input
    type="text"
    value={acconto}
    onChange={(e) => setAcconto(e.target.value)}
    placeholder="Es. 50% alla firma del contratto"
  />
</div>

<div className="form-group">
  <label>Saldo</label>
  <input
    type="text"
    value={saldo}
    onChange={(e) => setSaldo(e.target.value)}
    placeholder="Es. Saldo a fine lavori"
  />
</div>

<div className="form-group">
  <label>Validità del preventivo</label>
  <input
    type="text"
    value={validitaPreventivo}
    onChange={(e) => setValiditaPreventivo(e.target.value)}
    placeholder="Es. 30 giorni dalla data di emissione"
  />
</div>

<div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: 8 }}>
  <button
    className="btn-secondary"
    onClick={aggiungiRigaManuale}
    type="button"
  >
    + Riga manuale
  </button>
</div>

        <div className="lista-fatture-table-wrapper">
          <table className="data-table lista-fatture-table tabella-preventivo">
<thead>
  <tr>
    <th>Descrizione</th>
    <th>U</th>
    <th>Q.tà</th>
    <th>Prezzo CHF</th>
    <th>Sconto %</th>
    <th>Totale CHF</th>
    <th>Azioni</th>
  </tr>
</thead>

            <tbody>
              {righe.length === 0 ? (
                <tr>
                  <td colSpan="7">Nessuna riga. Clicca "+ Riga manuale".</td>
                </tr>
              ) : (
                righe.map((riga, indice) => (
                  <tr key={indice}>
                    <td>
                      <input
                        type="text"
                        value={riga.descrizione}
                        onChange={(e) =>
                          aggiornaRiga(indice, 'descrizione', e.target.value)
                        }
                        placeholder="Descrizione lavoro"
                      />
                    </td>
                    <td>
                      <select
                        value={riga.unita}
                        onChange={(e) =>
                          aggiornaRiga(indice, 'unita', e.target.value)
                        }
                      >
                        {UNITA_DISPONIBILI.map((unita) => (
                          <option key={unita} value={unita}>
                            {unita}
                          </option>
                        ))}
                      </select>
                    </td>
                    <td>
                      <input
                        type="number"
                        min="0"
                        step="0.01"
                        value={riga.quantita}
                        onChange={(e) =>
                          aggiornaRiga(indice, 'quantita', e.target.value)
                        }
                      />
                    </td>
<td>
  <input
    type="number"
    min="0"
    step="0.01"
    value={riga.prezzo}
    onChange={(e) =>
      aggiornaRiga(indice, 'prezzo', e.target.value)
    }
  />
</td>
<td>
  <input
    type="number"
    min="0"
    max="100"
    step="0.01"
    value={riga.scontoRiga}
    onChange={(e) =>
      aggiornaRiga(indice, 'scontoRiga', e.target.value)
    }
    placeholder=""
  />
</td>
<td>CHF {fmtCHF(riga.totale)}</td>
                    <td>
                      <button
                        className="btn-delete"
                        type="button"
                        onClick={() => rimuoviRiga(indice)}
                        title="Elimina riga"
                      >
                        <img
                          src="/icon-delete.svg"
                          alt="Elimina"
                          style={{ width: '28px', display: 'block' }}
                        />
                      </button>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>

<div style={{ marginTop: 20, maxWidth: 320, marginLeft: 'auto' }}>
  <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            <span>Subtotale</span>
            <span>CHF {fmtCHF(subtotale)}</span>
          </div>

          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            <span>Imponibile</span>
            <span>CHF {fmtCHF(imponibile)}</span>
          </div>

          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            <span>IVA 8.1%</span>
            <span>CHF {fmtCHF(iva)}</span>
          </div>

          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              fontWeight: 'bold',
              fontSize: 18,
              borderTop: '1px solid #333',
              marginTop: 6,
              paddingTop: 6,
            }}
          >
            <span>TOTALE</span>
            <span>CHF {fmtCHF(totale)}</span>
          </div>
        </div>

<button
  className="btn-primary full-width"
  onClick={salvaPreventivo}
  disabled={saving}
  type="button"
  style={{ marginTop: 20 }}
>
  {saving
    ? (preventivoDaModificare ? 'Salvataggio modifiche...' : 'Generazione preventivo...')
    : (preventivoDaModificare ? 'Salva modifiche e genera PDF' : 'Genera PDF e salva preventivo')}
</button>
      </div>
    </div>
  );
}